export const promoGamerCities = [
  {
    "provincia": "TODAS",
    "ciudades": [
      "TODAS"
    ]
  },
  {
    "provincia": "BUENOS AIRES",
    "ciudades": [
      "TODAS",
      "9 DE ABRIL",
      "9 DE JULIO",
      "ACASSUSO",
      "ADOLFO GONZALES CHAVES",
      "ADROGUE",
      "AVELLANEDA",
      "AZUL",
      "BAHIA BLANCA",
      "BALCARCE",
      "BANFIELD",
      "BELLA VISTA",
      "BENAVIDEZ",
      "Berazategui",
      "BERNAL",
      "BURZACO",
      "CARMEN DE ARECO",
      "CASEROS",
      "CASTELAR",
      "CHASCOMUS",
      "CIPOLETTI",
      "CITY BELL",
      "CIUDAD EVITA",
      "CIUDADELA",
      "CORONEL GRANADA",
      "CORONEL PRINGLES",
      "CORONEL SUAREZ",
      "DAIREAUX",
      "ENSENADA",
      "ESCOBAR",
      "EZEIZA",
      "FLORIDA",
      "FRANCISCO ALVAREZ",
      "GENERAL JUAN MADARIAGA",
      "GENERAL RODRIGUEZ",
      "GRAL PACHECO",
      "Gral. San Martín",
      "GUILLERMO E HUDSON",
      "HAEDO",
      "HURLINGHAM",
      "ISIDRO CASANOVA",
      "ITUZAINGO",
      "J. L. SUAREZ",
      "Jauregui",
      "JOSE C. PAZ",
      "JUNIN",
      "LA PLATA",
      "LA UNION FERROVIARIA, EZEIZA",
      "LANUS",
      "LANUS ESTE",
      "LANUS OESTE",
      "LAS ARMAS",
      "LAS FLORES",
      "LISANDRO OLMOS",
      "LOMA HERMOSA",
      "LOMAS DE ZAMORA",
      "LUJAN",
      "MAR DE AJO - SAN BERNARDO",
      "MAR DEL PLATA",
      "MARCOS PAZ",
      "MARTINEZ",
      "MATHEU",
      "MERLO",
      "MONTE GRANDE",
      "MORENO",
      "MUNRO",
      "NECOCHEA",
      "NECOCHEA - QUEQUEN",
      "Olivos",
      "PEDRO LURO",
      "PEHUAJO",
      "PILAR",
      "PINAMAR",
      "QUILMES",
      "RAFAEL CASTILLO",
      "REMEDIOS DE ESCALADA",
      "SAN CARLOS DE BOLIVAR",
      "SAN FERNANDO",
      "SAN ISIDRO",
      "SAN JUSTO",
      "SAN MARTIN",
      "SAN MIGUEL",
      "SAN PEDRO",
      "SAN VICENTE",
      "SANTA TERESITA - MAR DEL TUYU",
      "SARANDI",
      "TANDIL",
      "TEMPERLEY",
      "TIGRE",
      "TORTUGUITAS",
      "TRES ARROYOS",
      "TRISTAN SUAREZ",
      "VEDIA",
      "VILLA ADELINA",
      "VILLA BALLESTER",
      "VILLA GARIBALDI",
      "VILLA GESELL",
      "VIRREY DEL PINO"
    ]
  },
  {
    "provincia": "CATAMARCA",
    "ciudades": [
      "TODAS",
      "SAN FERNANDO DEL VALLE DE CATAMARCA"
    ]
  },
  {
    "provincia": "CHACO",
    "ciudades": [
      "TODAS",
      "SAENZ PEÑA",
      "CHARATA",
      "LAS BREÑAS",
      "PAMPA DEL INFIERNO",
      "PRESIDENCIA ROQUE SAENZ PEÑA",
      "QUITILIPI",
      "RESISTENCIA",
      "VILLA ANGELA"
    ]
  },
  {
    "provincia": "CIUDAD AUTONOMA DE BUENOS AIRES",
    "ciudades": [
      "TODAS",
      "CIUDAD AUTONOMA DE BUENOS AIRES"
    ]
  },
  {
    "provincia": "CÓRDOBA",
    "ciudades": [
      "TODAS",
      "ALTA GRACIA",
      "BERROTARAN",
      "COLONIA CAROYA",
      "CORDOBA",
      "CÓRDOBA",
      "FREYRE",
      "GENERAL CABRERA",
      "MALAGUEÑO",
      "MALVINAS ARGENTINAS",
      "MARCOS JUAREZ",
      "RIO CUARTO",
      "SINSACATE",
      "VICUÑA MACKENNA",
      "VILLA CARLOS PAZ",
      "VILLA CIUDAD DE AMERICA",
      "VILLA MARIA"
    ]
  },
  {
    "provincia": "CORRIENTES",
    "ciudades": [
      "TODAS",
      "CORRIENTES",
      "SALADAS"
    ]
  },
  {
    "provincia": "ENTRE RIOS",
    "ciudades": [
      "TODAS",
      "CEIBAS",
      "CONCORDIA",
      "GUALEGUAYCHU",
      "MARIA GRANDE",
      "PARANA",
      "ROSARIO DEL TALA",
      "VILLAGUAY"
    ]
  },
  {
    "provincia": "FORMOSA",
    "ciudades": [
      "TODAS",
      "FORMOSA"
    ]
  },
  {
    "provincia": "LA PAMPA",
    "ciudades": [
      "TODAS",
      "GENERAL PICO",
      "REALICO",
      "SANTA ROSA"
    ]
  },
  {
    "provincia": "MENDOZA",
    "ciudades": [
      "TODAS",
      "COSTA DE ARAUJO",
      "GODOY CRUZ",
      "MENDOZA"
    ]
  },
  {
    "provincia": "MISIONES",
    "ciudades": [
      "TODAS",
      "POSADAS",
      "PUERTO ESPERANZA",
      "PUERTO LIBERTAD",
      "PUERTO RICO",
      "SAN VICENTE"
    ]
  },
  {
    "provincia": "RIO NEGRO",
    "ciudades": [
      "TODAS",
      "CHOELE CHOEL",
      "SAN ANTONIO OESTE"
    ]
  },
  {
    "provincia": "SALTA",
    "ciudades": [
      "TODAS",
      "CERRILLOS",
      "SALTA"
    ]
  },
  {
    "provincia": "SAN LUIS",
    "ciudades": [
      "TODAS",
      "MERLO",
      "VILLA MERCEDES"
    ]
  },
  {
    "provincia": "SANTA FE",
    "ciudades": [
      "TODAS",
      "ESPERANZA",
      "PUEBLO ESTHER",
      "RAFAELA",
      "RECONQUISTA",
      "ROSARIO",
      "SAN JORGE",
      "SANTA FE"
    ]
  },
  {
    "provincia": "SANTIAGO DEL ESTERO",
    "ciudades": [
      "TODAS",
      "VILLA OJO DE AGUA"
    ]
  },
  {
    "provincia": "TUCUMAN",
    "ciudades": [
      "TODAS",
      "BANDA DEL RIO SALI",
      "FAMAILLA",
      "SAN MIGUEL DE TUCUMAN",
      "YERBA BUENA"
    ]
  }
] as const